import api from "@/api/axios";
import type { Configuration, PublicConfiguration } from "@/types/configuration";

const CONFIGURATION_API_ENDPOINTS = {
  ALL: "/configurations",
  PRIMARY: "/configurations/primary",
  PUBLIC_PRIMARY: "/configurations/public/primary",
} as const;

export const configurationService = {
  getAll: async (): Promise<Configuration[]> => {
    const response = await api.get<Configuration[]>(
      CONFIGURATION_API_ENDPOINTS.ALL,
    );
    return response.data;
  },

  getPrimary: async (): Promise<Configuration | null> => {
    const response = await api.get<Configuration | null>(
      CONFIGURATION_API_ENDPOINTS.PRIMARY,
    );
    return response.data;
  },

  getPublicPrimary: async (): Promise<PublicConfiguration | null> => {
    const response = await api.get<PublicConfiguration | null>(
      CONFIGURATION_API_ENDPOINTS.PUBLIC_PRIMARY,
    );
    return response.data;
  },
};
